import script from "./DirectionFilters.vue?vue&type=script&setup=true&lang=js"
export * from "./DirectionFilters.vue?vue&type=script&setup=true&lang=js"

import "./DirectionFilters.vue?vue&type=style&index=0&id=40387f4b&scoped=true&lang=scss"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40387f4b"]])

export default __exports__